__turbopack_context__.v({
  "root": "SectionElements-module-scss-module__4sVkCG__root",
  "root__actionButton": "SectionElements-module-scss-module__4sVkCG__root__actionButton",
  "root__content": "SectionElements-module-scss-module__4sVkCG__root__content",
  "root__header": "SectionElements-module-scss-module__4sVkCG__root__header",
  "root__items": "SectionElements-module-scss-module__4sVkCG__root__items",
  "variant_slider": "SectionElements-module-scss-module__4sVkCG__variant_slider",
  "variant_subsection": "SectionElements-module-scss-module__4sVkCG__variant_subsection",
});
